import { IOnTimeDeparture } from "../../../api/OnTimeDeparture/OnTimeDeparture.types";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IOnTimeDeparture[]
}

function OnTimeDeparture({ data }: Props) {
  const centeredMetric = ({ centerX, centerY }: any) => {
    if (data && data[0]) {
      const onTimeCount = Number(data[0].onTimeCount),
            earlyCount = Number(data[0].earlyCount),
            totalCount = Number(data[0].totalCount);

      const onTimePercentage = ((onTimeCount + earlyCount) / totalCount * 100).toFixed(2);

      return (
        <text
          x={centerX}
          y={centerY}
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fontSize: '24px',
            fontWeight: 600,
          }}
        >
          {onTimePercentage}%
        </text>
      )
    }
  }

  function getData() {
    if (data && data[0]) {
      const onTimeDeparture = data[0];
      const onTimeData = [
        {
          id: "Late Count",
          label: "Late",
          value: onTimeDeparture.lateCount
        },
        {
          id: "Extremely Late Count",
          label: "Extremely Late",
          value: onTimeDeparture.extremelyLateCount
        },
        {
          id: "On Time Count",
          label: "On Time",
          value: onTimeDeparture.onTimeCount
        },
        {
          id: "Early Count",
          label: "Early",
          value: onTimeDeparture.earlyCount
        },
      ];

      return onTimeData;
    }
  }

  return (
    <div className="on-time-departure">
      <WidgetNivoBase.Pie
        title={
          <Tooltips
            label={
              <>
                <span><b>On time Count</b> - Actual Departure date or today &lt; 3 days after Sail Date</span>
                <span><b>Late Count</b> - Actual Departure date or today 3~6 days after Sail Date</span>
                <span><b>Extremely Late Count</b> - Actual Departure date or today 7+ days after Sail Date</span>
                <span>Only includes data with Shipment having Sail Date and Acutal Departure Date</span>
              </>
            }
            children="On Time Departure"
          />
        }
        data={getData()}
        startAngle={-225}
        innerRadius={0.6}
        sortByValue={false}
        colors={{ scheme: "category10" }}
        enableArcLabels={true}
        arcLabelsSkipAngle={10}
        enableArcLinkLabels={true}
        arcLinkLabel="label"
        arcLinkLabelsTextColor={{ from: 'color', modifiers: [] }}
        arcLinkLabelsColor={{ from: 'color', modifiers: [] }}
        activeOuterRadiusOffset={8}
        centeredMetric={centeredMetric}
      />
    </div>
  )
}

export default OnTimeDeparture;
